import React from "react";
import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_warrior-trading-labs/artifacts/jkbsc49f_logo.png";

export const Logo = ({ size = "md", showSub = true }) => {
  const dims = size === "sm" ? "h-7 w-7" : size === "lg" ? "h-11 w-11" : "h-9 w-9";
  return (
    <Link to="/" className="inline-flex items-center gap-3 group" data-testid="brand-logo">
      <span
        className={`${dims} inline-flex items-center justify-center rounded-md bg-[#111111] border border-[#ff7a00]/40 p-1 glow-orange-soft transition-all group-hover:border-[#ff7a00] group-hover:scale-[1.03]`}
      >
        <img
          src={LOGO_URL}
          alt="Funded Index"
          className="h-full w-full object-contain drop-shadow-[0_0_6px_rgba(255,122,0,0.55)]"
          loading="eager"
          decoding="async"
          data-testid="brand-logo-img"
        />
      </span>
      <div className="flex flex-col leading-tight">
        <span className="text-[#f5f5f5] font-display font-bold tracking-tight text-base sm:text-lg">FUNDED INDEX</span>
        {showSub && (
          <span className="text-[#8a8a8a] text-[10px] sm:text-[11px] tracking-[0.2em] uppercase">
            For Index Traders
          </span>
        )}
      </div>
    </Link>
  );
};
